<template>
  <div class="name-reveal" :class="{ 'reveal-complete': isComplete }">
    <div class="name-container">
      <h1 class="name">
        <span class="name-part" v-for="(letter, index) in nameLetters" :key="index" :style="{ animationDelay: `${index * 0.1}s` }">
          {{ letter }}
        </span>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NameReveal',
  data() {
    return {
      name: 'Leo-Martin',
      isComplete: false,
      animationDuration: 2500 // in milliseconds
    }
  },
  computed: {
    nameLetters() {
      return this.name.split('')
    }
  },
  mounted() {
    // Emit event after animation completes
    setTimeout(() => {
      this.isComplete = true
      setTimeout(() => {
        this.$emit('reveal-complete')
      }, 500) // Fade out duration
    }, this.animationDuration)
  }
}
</script>

<style lang="scss" scoped>
.name-reveal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background, #ffffff);
  z-index: 1000;
  opacity: 1;
  transition: opacity 0.5s ease;
  
  &.reveal-complete {
    opacity: 0;
  }
}

.name-container {
  text-align: center;
}

.name {
  font-size: 4rem;
  font-weight: 700;
  letter-spacing: 2px;
  
  @media (max-width: 768px) {
    font-size: 3rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
}

.name-part {
  display: inline-block;
  opacity: 0;
  transform: translateY(20px);
  animation: revealLetter 0.5s forwards;
  color: var(--color-text, #333333);
  
  &:nth-child(odd) {
    color: var(--color-primary, #f8c630);
  }
}

@keyframes revealLetter {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style> 